import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Header as Desc } from './desk'
import { Header as Mob } from './mob'

import { Props } from './types'

export const Header: React.FC<Props> = (props) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob {...props} /> : <Desc {...props} />
}
